import { defineTarget } from "./types.ts";
import type { TargetProfile } from "./types.ts";

const FORMATS = new Set([
  "date-time",
  "time",
  "date",
  "duration",
  "email",
  "hostname",
  "uri",
  "ipv4",
  "ipv6",
  "uuid",
]);

export const anthropicMessagesStructured: TargetProfile = defineTarget({
  id: "anthropic/messages/structured",
  aliases: [
    "anthropic",
    "anthropic/structured",
    "claude",
    "anthropic/messages/tools",
    "anthropic/strict-tools",
  ],
  vendor: "anthropic",
  mode: "structured",
  revision: "2026-08",
  maturity: "supported",
  dialect: "2020-12",
  evidence: "documented",
  evidenceSource: "https://platform.claude.com/docs/en/build-with-claude/structured-outputs",
  lastVerified: "2026-08-18",
  liveAdapter: true,
  capabilities: {
    anyOf: "supported",
    oneOf: "lossy",
    allOf: "lossy",
    not: "unsupported",
    refs: "supported",
    recursiveRefs: "unsupported",
    defs: "supported",
    nullableTypeArray: "supported",
    optionalProperties: "supported",
    additionalPropertiesTrue: "unsupported",
    additionalPropertiesSchema: "unsupported",
    pattern: "supported",
    format: "supported",
    minLength: "runtime-only",
    maxLength: "runtime-only",
    minimum: "runtime-only",
    maximum: "runtime-only",
    exclusiveMinimum: "runtime-only",
    exclusiveMaximum: "runtime-only",
    multipleOf: "runtime-only",
    minItems: "lossy",
    maxItems: "runtime-only",
    uniqueItems: "runtime-only",
    prefixItems: "unsupported",
    minProperties: "runtime-only",
    maxProperties: "runtime-only",
    enum: "supported",
    const: "supported",
    integer: "supported",
    nullType: "supported",
  },
  formats: FORMATS,
  minItemsAllowed: new Set([0, 1]),
  limits: {
    maxOptionalProperties: 24,
  },
  objectPolicy: {
    additionalProperties: false,
    requireAllProperties: false,
    optionalAsNullable: false,
  },
  rootMustBeObject: false,
  rootAnyOf: "supported",
});
